__turbopack_context__.v({
  "chartsGrid": "ChartsWidgetsList-module__Fxui0a__chartsGrid",
  "container": "ChartsWidgetsList-module__Fxui0a__container",
  "emptySearch": "ChartsWidgetsList-module__Fxui0a__emptySearch",
  "errorAlert": "ChartsWidgetsList-module__Fxui0a__errorAlert",
  "heading": "ChartsWidgetsList-module__Fxui0a__heading",
  "list": "ChartsWidgetsList-module__Fxui0a__list",
  "listItem": "ChartsWidgetsList-module__Fxui0a__listItem",
  "pulse": "ChartsWidgetsList-module__Fxui0a__pulse",
  "skeletonChart": "ChartsWidgetsList-module__Fxui0a__skeletonChart",
  "skeletonHeading": "ChartsWidgetsList-module__Fxui0a__skeletonHeading",
});
